import React, { useEffect, useState } from "react";
import {fetch_quick_finance_ratio } from "../../ApisService/apiService";
import styles from "../../../css/dashboard/fundamental/QuickAnalysis.module.css";

const Quick_ratio_Analysis = ({ fincode }) => {
  const [data, setData] = useState([]);
  const [latestYear, setLatestYear] = useState(null);
  const [loading, setLoading] = useState(true);

  const quickMetrics = [
    { label: "ROE (%)", key: "ROE" },
    { label: "ROCE (%)", key: "ROCE" },
    { label: "EPS (₹)", key: "Reported_EPS" },
    { label: "Debt/Equity", key: "Total_Debt_Equity" },
    { label: "Current Ratio", key: "Current_Ratio" },
    { label: "Net Sales Growth (%)", key: "Net_Sales_Growth" },
    { label: "PAT Margin (%)", key: "PAT_Margin" },
    { label: "Dividend per share", key: "DPS" },
    { label: "Earnings growth", key: "EBIT_Growth" },
    { label: "Net margin", key: "EBIT_Margin" },
  ];

  useEffect(() => {
    const fetchData = async () => {
        if ( !fincode) return;
      
        setLoading(true);
        try {
          const response = await fetch_quick_finance_ratio(fincode);
          const ratios = response.data || [];
      
          const reversed = [...ratios].reverse(); // Reverse to get latest first
          const latest = reversed[0];
      
          setData(latest || {});
          setLatestYear(latest?.Year_end || null);
        } catch (error) {
          console.error("Quick analysis fetch error:", error);
        }
        setLoading(false);
      };
      

    fetchData();
  }, [fincode]);

  const formatFincode = (fincode) => {
    const fincodeNumber = parseInt(fincode, 10);
    const year = Math.floor(fincodeNumber / 100);
    const month = fincodeNumber % 100;
    const monthNames = [
      'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
      'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
    ];
    return `${monthNames[month - 1]} ${year}`;
  };

  return (
    <div className={styles.quickContainer}>
      <h3 className={styles.heading}>Quick Financial Analysis</h3>
      {loading ? (
        <p>Loading...</p>
      ) : (
        <>
          <p className={styles.subheading}>
            Latest Data: {latestYear ? formatFincode(latestYear) : "N/A"}
          </p>
          <div className={styles.cardGrid}>
            {quickMetrics.map((metric, index) => (
              <div className={styles.card} key={index}>
                <p className={styles.metricLabel}>{metric.label}</p>
                <p className={styles.metricValue}>
                  {data[metric.key] !== undefined ? data[metric.key] : "–"}
                </p>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default Quick_ratio_Analysis;
